import React from 'react';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { changemakerProjects } from '../../utils/BeadsData';

const ChangemakerProjects = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    // This function now directly influences the grid layout
    const getGridColumns = () => {
        if (isMobile) return 12
        if (isMediumScreen) return 6;
        return 4; // One third for large screens, allowing 3 items per row
    };

    return (
        <Box>
            <NavBar />
            <Box sx={{ my: 10, mx: 4, textAlign: 'center' }}>

                <Typography variant="h3" sx={{ margin: '2.5rem 0', fontWeight: '600' }}>
                    Changemaker Projects
                </Typography>

                <Grid container spacing={4}>
                    {changemakerProjects.map((project, index) => (
                        <Grid item xs={getGridColumns()} key={index}>
                            <Box
                                className={`project-container ${project.backSrc ? 'flip-effect' : ''}`}
                                sx={{
                                    position: 'relative',
                                    height: isMobile ? 200 : 270,
                                    overflow: 'hidden',
                                    borderRadius: '1rem',
                                    perspective: '1000px', // For the flip effect
                                    transition: project.backSrc ? 'none' : 'transform 0.5s ease', // Apply scale transition only if there's no backSrc
                                    '&:hover': {
                                        transform: project.backSrc ? 'none' : 'scale(1.05)', // Scale only if there's no backSrc
                                    },
                                    '.project-image-front, .project-image-back': {
                                        width: '100%',
                                        height: '100%',
                                        backfaceVisibility: 'hidden',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        transition: 'transform 0.6s linear',
                                    },
                                    '.project-image-front': {
                                        transform: project.backSrc ? 'rotateY(0deg)' : 'none', // No rotation if there's no backSrc
                                    },
                                    '.project-image-back': {
                                        transform: 'rotateY(180deg)',
                                        display: project.backSrc ? 'block' : 'none', // Hide back image if not available
                                    },
                                    '&:hover .project-image-front': project.backSrc ? {
                                        transform: 'rotateY(-180deg)',
                                    } : {},
                                    '&:hover .project-image-back': project.backSrc ? {
                                        transform: 'rotateY(0deg)',
                                    } : {},
                                }}
                            >
                                <img src={project.src} alt={project.alt} className="project-image-front" />
                                {project.backSrc && (
                                    <img src={project.backSrc} alt={project.alt} className="project-image-back" />
                                )}
                                <Typography className="project-description"
                                    sx={{
                                        position: 'absolute',
                                        bottom: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        fontSize: '.75rem',
                                        color: 'white',
                                        textAlign: 'center',
                                        padding: '8px',
                                    }}>
                                    {project.description}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <FooterOne />
        </Box>
    );
}

export default ChangemakerProjects;
